<template>
  <div class="menuLabel flex flexRight flexMiddle">
    <b-nav-item
      :class="menuName === 'record' ? 'activeNav' : ''"
      to="/record"
      right>申請履歴</b-nav-item>
    <b-nav-item
      :class="menuName === 'inquiry' ? 'activeNav' : ''"
      to="/inquiry/list"
      right>問合せ</b-nav-item>
    <b-nav-item-dropdown text="設定"
      :class="menuName === 'setting' ? 'activeNav' : ''"
      :toggle-class="/gasMy/.test($route.name) ? 'active' : ''">
      <b-dropdown-item to="/myInfo">ユーザー情報</b-dropdown-item>
      <b-dropdown-item to="/myAuth">認証情報</b-dropdown-item>
      <!-- No.9 (B)：代行者の自己設定。採択されている利用者のときだけ表示する。 -->
      <b-dropdown-item v-if="canUseAgent" to="/myAgent">代行者</b-dropdown-item>
    </b-nav-item-dropdown>
    <span
      @click="kickLogout"
      class="logout px-3"
      >ログアウト</span>
  </div>
</template>

<script>
import api from '@/modules/api';

export default {
  name: 'GasHeader',
  props: {
    menuName: { type: String, default: '' },
  },
  data() {
    return {
      // 採択されている利用者にだけ「代行者」メニューを出す（採択判定はサーバで行う）
      canUseAgent: false,
    };
  },
  async created() {
    // ヘッダーは全画面で描画されるため、TOP のデータ取得とは結合させず軽量な判定APIを1回だけ叩く
    const res = await api.send('/api/user/agents/visible').catch(() => false);
    if (res !== false) {
      this.canUseAgent = !!res.data.visible;
    }
  },
  methods: {
    kickLogout() {
      this.$emit('kickLogout');
    },
  },
};
</script>

<style scoped>
  .logout {
    border: solid;
    border-width: 0 0 0 1px;
    border-color: #ccc;
  }

  .logout:hover {
    cursor: pointer;
  }

  .menuLabel>li{
    list-style: none;
  }

</style>
